export function ProseTable({ children }) {
  return (
    <div className="w-full overflow-x-auto table-scroll my-[16px]">
      <table className="w-full min-w-max border-separate border-spacing-0 rounded-2xl m-0 border border-[#ececed]">
        {children}
      </table>
    </div>
  );
}

export function ProseTBody({ children, ...props }) {
  return (
    <tbody className="bg-white [&_td:first-child]:text-[#636369] [&_td:not(:first-child)]:text-[#111827] [&_td:not(:first-child)]:text-right [&_tr:last-child_td:first-child]:rounded-bl-2xl [&_tr:last-child_td:last-child]:rounded-br-2xl [&_td:first-child]:sticky [&_td:first-child]:left-0 [&_td:first-child]:z-10 [&_td:first-child]:bg-white [&_tr:hover_td:first-child]:bg-gray-50/40" {...props}>
      {children}
    </tbody>
  );
}

export function ProseTHead({ children, ...props }) {
  return (
    <thead className="bg-[#f5f5f5] [&_th:first-child]:rounded-tl-2xl [&_th:last-child]:rounded-tr-2xl [&_th:not(:first-child)]:text-right [&_th:first-child]:sticky [&_th:first-child]:left-0 [&_th:first-child]:z-10 [&_th:first-child]:bg-[#f5f5f5]" {...props}>
      {children}
    </thead>
  );
}

export function ProseTR({ node, children, ...props }) {
  const isBody = node?.parentNode?.tagName === "tbody";
  return (
    <tr
      className={isBody ? "hover:bg-gray-50/40 transition-colors" : ""}
      {...props}
    >
      {children}
    </tr>
  );
}

export function ProseTH({ children, ...props }) {
  return (
    <th
      className="text-sm font-medium text-[#636369] px-5 py-2.5 leading-5 whitespace-nowrap text-left"
      {...props}
    >
      {children}
    </th>
  );
}

export function ProseTD({ children, ...props }) {
  return (
    <td
      className="text-base font-medium px-5 py-4 leading-6 align-top border-t border-[#ececed]"
      {...props}
    >
      {children}
    </td>
  );
}
